<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    transition="dialog-bottom-transition"
    :overlay=false
    scrollable
  >
    <v-card tile>
      <v-toolbar card dark color="primary">
        <v-btn icon @click.native="dialog = false" dark>
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ addon.name }}</v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
      <v-card-text>
        Hello!
      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'AddonDetails',
    props: {
      addon: Boolean,
      dialog: Object
    },
    data () {
      return {};
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AddonDetails/AddonDetails.vue